import { SOCKET } from './initWebSocket';

const provideGlobalWebSocketBridge = () => {
  // Global function to continuously send new WebSocket connections to chatbot
  window.getWebSocketNewConnection = (callback) => {
    console.log("CHATBOT BRIDGE: Setting up continuous WebSocket connection tracking for chatbot");

    if (callback && typeof callback === 'function') {
      let lastSentWs = null;

      // Track WebSocket changes
      const trackingInterval = setInterval(() => {
        const currentWs = SOCKET.ws;

        // Send WebSocket if it's different from last sent or if connection status changed
        if (currentWs !== lastSentWs) {
          console.log("CHATBOT BRIDGE: New WebSocket detected", {
            readyState: currentWs?.readyState,
            isConnected: currentWs?.readyState === WebSocket.OPEN,
            wsExists: !!currentWs
          });

          // Send new WebSocket instance to chatbot
          callback(currentWs);
          lastSentWs = currentWs;
        }
      }, 100); // Check every 100ms

      // Immediately send current WebSocket
      callback(SOCKET.ws);
      lastSentWs = SOCKET.ws;

      // Return cleanup function
      return () => {
        clearInterval(trackingInterval);
        console.log("CHATBOT BRIDGE: WebSocket tracking stopped");
      };
    } else {
      console.error("CHATBOT BRIDGE: Invalid callback provided for WebSocket tracking");
      return null;
    }
  };
}
export default provideGlobalWebSocketBridge

